import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslationService } from 'src/app/service/translation-service/translation.service';
import { userManuals } from '../helping-material.util';

@Component({
  selector: 'app-helping-material-list',
  templateUrl: './helping-material-list.component.html',
  styleUrls: ['./helping-material-list.component.css']
})
export class HelpingMaterialListComponent implements OnInit, OnDestroy {

  pdfUrl = null;
  ind = 0;
  userManuals = [];
  private localeSub: Subscription;

  constructor(
    private router: Router,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    this.refreshManuals();
    this.localeSub = this.translationService.locale$.subscribe(() => {
      this.refreshManuals();
    });
  }

  private refreshManuals() {
    this.userManuals = userManuals.map(manual => ({
      ...manual,
      name:
        this.translationService.getTranslation(manual.nameKey) ||
        manual.name
    }));
  }

  openPdfPopup(ind) {
    if (this.userManuals[ind].url) {
      window.open('/helpingmaterial/pdf/' + ind, '_blank');
    }
  }

  set(ind) {
    this.pdfUrl = this.userManuals[ind].url;
  }

  getActivePdf() {
    return this.pdfUrl;
  }

  ngOnDestroy() {
    if (this.localeSub) {
      this.localeSub.unsubscribe();
    }
  }
}
